import { createGlobalStyle } from "styled-components";
import GibsonBold from "./GibsonBold.woff";
import GibsonBoldIt from "./GibsonBoldIt.woff";
import GibsonItalic from "./GibsonItalic.woff";
import GibsonLight from "./GibsonLight.woff";
import GibsonLightIt from "./GibsonLightIt.woff";
import GibsonRegular from "./GibsonRegular.woff";
import GibsonSemiBd from "./GibsonSemiBd.woff";
import GibsonSemiBdIt from "./GibsonSemiBdIt.woff";

export default createGlobalStyle`
    @font-face {
        font-family: 'GibsonBold';
        src: local('Gibson Bold'), local('GibsonBold'),
        url(${GibsonBold}) format('woff2'),
        url(${GibsonBold}) format('woff');
        font-weight: 300;
        font-style: normal;
    }

    @font-face {
        font-family: 'GibsonBoldIt';
        src: local('GibsonBoldIt'), local('GibsonBoldIt'),
        url(${GibsonBoldIt}) format('woff2'),
        url(${GibsonBoldIt}) format('woff');
        font-weight: 300;
        font-style: normal;
    }


    @font-face {
        font-family: 'GibsonItalic';
        src: local('GibsonItalic'), local('GibsonItalic'),
        url(${GibsonItalic}) format('woff2'),
        url(${GibsonItalic}) format('woff');
        font-weight: 300;
        font-style: normal;
    }

    @font-face {
        font-family: 'GibsonLight';
        src: local('GibsonLight'), local('GibsonLight'),
        url(${GibsonLight}) format('woff2'),
        url(${GibsonLight}) format('woff');
        font-weight: 300;
        font-style: normal;
    }

    @font-face {
        font-family: 'GibsonLightIt';
        src: local('GibsonLightIt'), local('GibsonLightIt'),
        url(${GibsonLightIt}) format('woff2'),
        url(${GibsonLightIt}) format('woff');
        font-weight: 300;
        font-style: normal;
    }


    @font-face {
        font-family: 'GibsonRegular';
        src: local('GibsonRegular'), local('GibsonRegular'),
        url(${GibsonRegular}) format('woff2'),
        url(${GibsonRegular}) format('woff');
        font-weight: 300;
        font-style: normal;
    }


    @font-face {
        font-family: 'GibsonSemiBd';
        src: local('GibsonRegular'), local('GibsonSemiBd'),
        url(${GibsonSemiBd}) format('woff2'),
        url(${GibsonSemiBd}) format('woff');
        font-weight: 300;
        font-style: normal;
    }


    @font-face {
        font-family: 'GibsonSemiBdIt';
        src: local('GibsonSemiBdIt'), local('GibsonSemiBdIt'),
        url(${GibsonSemiBdIt}) format('woff2'),
        url(${GibsonSemiBdIt}) format('woff');
        font-weight: 300;
        font-style: normal;
    }

    

`;
